import _ from "lodash";
import { getToken } from "@/utils/auth";
import request from "@/utils/request";

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function arrayToTree(data, id, parentId, children) {
  let config = {
    id: id || "id",
    parentId: parentId || "parentId",
    childrenList: children || "children",
  };

  var childrenListMap = {};
  var nodeIds = {};
  var tree = [];

  for (let d of data) {
    let parentId = d[config.parentId];
    if (childrenListMap[parentId] == null) {
      childrenListMap[parentId] = [];
    }
    nodeIds[d[config.id]] = d;
    childrenListMap[parentId].push(d);
  }

  for (let d of data) {
    let parentId = d[config.parentId];
    if (nodeIds[parentId] == null) {
      tree.push(d);
    }
  }

  for (let t of tree) {
    adaptToChildrenList(t);
  }

  function adaptToChildrenList(o) {
    if (childrenListMap[o[config.id]] !== null) {
      o[config.childrenList] = childrenListMap[o[config.id]];
    }
    if (o[config.childrenList]) {
      for (let c of o[config.childrenList]) {
        adaptToChildrenList(c);
      }
    }
  }

  return tree;
}

// tree中匹配的项
export function treematch(tree, value, key = "id", childrenProp = "children") {
  let matchValue;
  for (let i = 0; i < tree.length; i++) {
    if (tree[i][key] == value) {
      matchValue = tree[i];
      break;
    } else {
      if (tree[i][childrenProp] && tree[i][childrenProp].length) {
        matchValue = treematch(tree[i][childrenProp], value, key, childrenProp);
        if (matchValue) break;
      }
    }
  }
  return matchValue;
}
// json数据中根据指定项找到所有父级 tree=>json数据 value=>要匹配的值 key=>json数据中匹配属性名 params=>返回的属性名
export function getParentNode(
  tree,
  value,
  key = "id",
  params = "id",
  childrenProp = "children",
  path
) {
  if (path === undefined) {
    path = [];
  }
  for (let i = 0; i < tree.length; i++) {
    let temPath = path.concat();
    temPath.push(tree[i][params]);
    if (value == tree[i][key]) {
      return temPath;
    }
    if (tree[i][childrenProp]) {
      let findResult = getParentNode(
        tree[i][childrenProp],
        value,
        key,
        params,
        childrenProp,
        temPath
      );
      if (findResult) {
        return findResult;
      }
    }
  }
}
// 递归删除对象中children为空数组的字段
export function deleteNullChild(data) {
  for (let i = 0; i < data.length; i++) {
    if (!data[i].children) {
      return;
    }
    if (data[i].children.length == 0) {
      let { children, ...items } = data[i];
      data[i] = items;
    } else {
      deleteNullChild(data[i].children);
    }
  }
  return data;
}

// 递归删除对象中children为空数组的字段
export function deleteNullChi(data, name = "children") {
  for (let i = 0; i < data.length; i++) {
    if (!data[i][name]) {
      return;
    }
    if (data[i][name].length == 0) {
      let { children, ...items } = data[i];
      data[i] = items;
    } else {
      deleteNullChild(data[i][name]);
    }
  }
  return data;
}
/**
 *
 * @param {*} data 查询数据
 * @param {*} childKeyword 子选项关键字
 * @param {*} keyword 获取数据的关键字
 * @returns
 */
export function getParentKey(
  data,
  result = [],
  childKeyword = "children",
  keyword = "id"
) {
  for (let i of data) {
    if (i[childKeyword]?.length) {
      result.push(i[keyword]);
      getParentKey(i[childKeyword], result);
    }
  }
  return result;
}

export function S4() {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
}
// 生成guid
export function guid() {
  return (
    S4() +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    S4() +
    S4()
  );
}

//获取URL参数
export function getParams(path) {
  let url = path;
  let arrObj = url.split("?");
  let params = Object.create(null);
  if (arrObj.length > 1) {
    arrObj = arrObj[1].split("&");
    arrObj.forEach((item) => {
      item = item.split("=");
      params[item[0]] = item[1];
    });
  }
  return params;
}

/** 导出
 * @param {string} path
 * @param {string} name
 *** */
export function exportFile(path, data, name, type) {
  console.log(type, "========");
  request({
    url: path,
    method: "POST",
    data: data,
    type: type ? type : null,
    responseType: "blob",
  }).then((blob) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob); // 转换为base64，可以直接放入a标签href
    reader.onload = (e) => {
      // 转换完成，创建一个a标签用于下载
      let a = document.createElement("a");
      a.style.display = "none";
      a.download = name;
      a.href = e.target.result;
      const body = document.body;
      document.body.appendChild(a); // 修复firefox中无法触发click
      a.click();
      document.body.removeChild(a);
    };
  });
}
// 将树转为一维数组
export const treeLevelArray = function (tree, result = []) {
  for (let i = 0; i < tree.length; i++) {
    result.push(tree[i]);
    if (tree[i].children && tree[i].children.length) {
      treeLevelArray(tree[i].children, result);
      Reflect.deleteProperty(tree[i], "children");
    }
  }
  return result;
};
// 获取json树每项的最后一级
export const geTreeLastItem = function (tree, result = []) {
  for (let i = 0; i < tree.length; i++) {
    if (tree[i].children && tree[i].children.length) {
      geTreeLastItem(tree[i].children, result);
    } else {
      result.push(tree[i]);
    }
  }
  return result;
};

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}
